document.documentElement.classList.add('no-touch')
window.addEventListener('touchstart', () => {
  document.documentElement.classList.remove('no-touch')
}, { once: true })
